import React from 'react';
import PropTypes from 'prop-types';

import SelectUserLockOperationAction from '../SelectUserLockOperationAction';
import SelectPinCode from '../SelectPinCode';
import { getUserLockOperationState } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/getUserLockOperationState';
import { getUserLockOperationUser } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/getUserLockOperationUser';
import { isPinRequiredForAction } from 'containers/Ezlo/EzloMeshbot/utils/deviceNode/isPinRequiredForAction';

/**
 * Sub-block for isUserLockOperation capabilities (any value type of the method, e.g. keypad user_code_action and
 * door lock user_lock_operation): an action select + a PIN select shown only for actions that require a PIN.
 * Store-driven for the current values (reads from the trigger); its config entry is passed in whole as `behavior`
 * by the container, and this component takes what it needs (actionOptions) — so it stays config-free. No local state.
 * @param {object} props
 * @returns {JSX.Element}
 */
const UserLockOperationFieldsBlock = ({ behavior, deviceId, items, onDataUpdate, ruleTrigger }) => {
    const actionOptions = behavior?.actionOptions;
    const selectedAction = getUserLockOperationState(ruleTrigger);
    const selectedPinCode = getUserLockOperationUser(ruleTrigger);

    return (
        <>
            <SelectUserLockOperationAction
                actionOptions={actionOptions}
                items={items}
                deviceId={deviceId}
                selectedAction={selectedAction}
                onDataUpdate={onDataUpdate}
            />
            {isPinRequiredForAction(actionOptions, selectedAction) && (
                <SelectPinCode
                    items={items}
                    deviceId={deviceId}
                    selectedAction={selectedAction}
                    onDataUpdate={onDataUpdate}
                    selectedPinCode={selectedPinCode}
                />
            )}
        </>
    );
};

export default UserLockOperationFieldsBlock;

UserLockOperationFieldsBlock.propTypes = {
    behavior: PropTypes.object,
    deviceId: PropTypes.string,
    items: PropTypes.array,
    onDataUpdate: PropTypes.func,
    ruleTrigger: PropTypes.object,
};
